import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-querybuilder/dist/query-builder.css";
import "react-quill/dist/quill.snow.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <GoogleOAuthProvider clientId="221070665672-7p3r5qnucnhj7ukai3ngjaluactecurd.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
